import { Component, EventEmitter, Input, Output, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AddPopupComponent } from '../add-popup/add-popup.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faXmark, faTrashCan } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-department-table',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, AddPopupComponent, FontAwesomeModule],
  templateUrl: './department-table.component.html',
  styleUrls: ['./department-table.component.css']
})
export class DepartmentTableComponent implements OnInit, OnChanges {
  faXmark = faXmark;
  faTrashCan = faTrashCan;
  showAddEditModal = false;
  showDeleteModal = false;
  isEditMode = false;
  showSkeleton = true;
  
  departmentForm: FormGroup;
  @Input() departments: any[] = [];
  @Input() loading = false;
  @Output() addDepartment = new EventEmitter<any>();
  @Output() editDepartment = new EventEmitter<{ id: any, data: any }>();
  @Output() deleteDepartment = new EventEmitter<any>();
  selectedDepartmentId: number | null = null;

  constructor(private fb: FormBuilder) {
    this.departmentForm = this.fb.group({
      title: ['', Validators.required],
      subDeps: ['', Validators.required]
    });
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['loading'] && changes['loading'].currentValue) {
      this.showTableLoader();
    }
  }
  ngOnInit(): void {
    this.showTableLoader();
  }
  skeletonRows: any[] = [];
  skeletonCols: any[] = [];

  showTableLoader(duration = 800) {
    this.showSkeleton = true;

    const DEFAULT_ROWS = 5;
    const rowCount = (this.departments && this.departments.length) ? this.departments.length : DEFAULT_ROWS;
    const columnCount = 3;
    this.skeletonRows = Array(rowCount).fill(0);
    this.skeletonCols = Array(columnCount).fill(0);

    setTimeout(() => {
      this.showSkeleton = false;
    }, duration);
  }
  getSubDepartments(subDepString: string): string[] {
    if (!subDepString) return [];
    return subDepString.split(',').map(s => s.trim()).filter(s => s.length > 0);
  }

  toggleModal(type: 'add' | 'delete') {
    if (type === 'add') {
      this.showAddEditModal = !this.showAddEditModal;
      if (!this.showAddEditModal) {
        this.isEditMode = false;
        this.selectedDepartmentId = null;
        this.departmentForm.reset();
      }
    } else if (type === 'delete') {
      this.showDeleteModal = !this.showDeleteModal;
    }
  }

  openEditModal(item: any) {
    this.isEditMode = true;
    this.showAddEditModal = true;
    this.selectedDepartmentId = item.id;

    this.departmentForm.patchValue({
      title: item.department_name,
      subDeps: item.sub_department_name
    });
  }

  openDeleteModal(item: any) {
    this.selectedDepartmentId = item.id;
    this.showDeleteModal = true;
  }

  confirmDelete() {
    if (this.selectedDepartmentId !== null) {
      this.deleteDepartment.emit(this.selectedDepartmentId);
      this.toggleModal('delete');
      this.selectedDepartmentId = null;
    }
  }

  onSave() {
    if (this.departmentForm.valid) {
      const formValue = this.departmentForm.value;
      const formattedData = {
        dep_name: formValue.title,
        subdep_name: formValue.subDeps
      };

      if (this.isEditMode && this.selectedDepartmentId !== null) {
        this.editDepartment.emit({ id: this.selectedDepartmentId, data: formattedData });
      } else {
        this.addDepartment.emit(formattedData);
      }
      this.toggleModal('add');
    }
  }
}
